/* eslint-disable no-use-before-define */

/* eslint-disable no-unused-vars */

/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import {
  Platform,
  Animated,
  StyleProp,
  ViewStyle,
  StyleSheet,
  View,
  TextStyle,
  Easing,
} from "react-native";
import { interpolate } from "flubber";
import SVG_Svg, {
  G as SVG_G,
  Path as SVG_Path,
  Text as SVG_Text,
  TSpan as SVG_TSpan,
  GProps,
  PathProps,
} from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

const TSpan = Animated.createAnimatedComponent(SVG_TSpan);
const Text = Animated.createAnimatedComponent(SVG_Text);
const Path = Animated.createAnimatedComponent<
  React.ComponentClass<
    PathProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_Path);
const G = Animated.createAnimatedComponent<
  React.ComponentClass<
    GProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);
import FontList from "react-native-font-list";
/***/

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG - STATE 0
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="652" height="170" viewBox="0 0 652 170" fill="none"> <desc id="IMP.BLUE">{"#Open_3Dfalse":{"type":"SELECTOR","constraint":"xMinYMin meet","width":651,"height":166},"#Rectangle_20390":{"type":"SELECTOR","constraint":"none","width":651,"height":166},"#MagicBox":{"type":"SELECTOR","constraint":"xMinYMin meet","width":85.80531311035156,"height":59.88495635986328},"#Rectangle_20391":{"type":"SELECTOR","constraint":"xMinYMin meet","width":35.3053092956543,"height":27.707963943481445},"#Vector_202":{"type":"SELECTOR","constraint":"xMinYMin meet","width":13.407079696655273,"height":7.597345352172852},"#Vector_203":{"type":"SELECTOR","constraint":"xMinYMin meet","width":13.407079696655273,"height":7.597345352172852},"#Subtract":{"type":"SELECTOR","constraint":"xMinYMin meet","width":9.83185863494873,"height":17.75012969970703},"#Top":{"type":"SELECTOR","constraint":"xMinYMin meet","width":39.05039978027344,"height":22.790143966674805},"#Star_201":{"type":"SELECTOR","constraint":"xMinYMin meet","width":4.915929317474365,"height":6.256637096405029},"#Star_202":{"type":"SELECTOR","constraint":"xMinYMin meet","width":4.915929317474365,"height":4.915929317474365},"#Star_203":{"type":"SELECTOR","constraint":"xMinYMin meet","width":7.597345352172852,"height":7.597345352172852},"#Star_204":{"type":"SELECTOR","constraint":"xMinYMin meet","width":8.938053131103516,"height":7.597345352172852},"#Open_3Dtrue":{"type":"SELECTOR","constraint":"xMinYMin meet","width":651,"height":166},"transforms":{"PromotionNotice_20Master":[{"name":"PromotionNotice_20Master","relativeTransforms":[[1,0,0],[0,1,0]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":true,"isInstanceChild":false,"width":651,"height":166},{"name":"PromotionNotice_20Master","relativeTransforms":[[1,0,0],[0,1,0]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":true,"isInstanceChild":false,"width":651,"height":166}],"baackground":[{"name":"baackground","relativeTransforms":[[1,0,0],[0,1,-4]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":651,"height":166},{"name":"baackground","relativeTransforms":[[1,0,0],[0,1,-4]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":651,"height":166}],"discount":[{"name":"discount","relativeTransforms":[[1,0,31],[0,1,109]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":79,"height":25},{"name":"discount","relativeTransforms":[[1,0,31],[0,1,109]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":79,"height":25}],"dash2":[{"name":"dash2","relativeTransforms":[[1,0,88],[0,1,121]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":17,"height":0},{"name":"dash2","relativeTransforms":[[1,0,88],[0,1,121]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":17,"height":0}],"dash1":[{"name":"dash1","relativeTransforms":[[1,0,36],[0,1,121]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":17,"height":0},{"name":"dash1","relativeTransforms":[[1,0,36],[0,1,121]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":17,"height":0}],"myPromotionCopy":[{"name":"myPromotionCopy","relativeTransforms":[[1,0,135],[0,1,79]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":455,"height":50},{"name":"myPromotionCopy","relativeTransforms":[[1,0,135],[0,1,79]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":455,"height":50}],"myDiscountCode":[{"name":"myDiscountCode","relativeTransforms":[[1,0,135],[0,1,33]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":314,"height":33},{"name":"myDiscountCode","relativeTransforms":[[1,0,135],[0,1,33]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":314,"height":33}],"myDiscount":[{"name":"myDiscount","relativeTransforms":[[1,0,28],[0,1,68]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":80,"height":46},{"name":"myDiscount","relativeTransforms":[[1,0,28],[0,1,68]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":80,"height":46}],"myRestrictions":[{"name":"myRestrictions","relativeTransforms":[[1,0,264],[0,1,137]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":373,"height":24},{"name":"myRestrictions","relativeTransforms":[[1,0,264],[0,1,137]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":373,"height":24}],"MagicBox":[{"name":"MagicBox","relativeTransforms":[[1,0,49],[0,1,12]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":true,"isInstanceChild":true,"width":85.80531311035156,"height":59.88495635986328},{"name":"MagicBox","relativeTransforms":[[1,0,49],[0,1,12]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":true,"isInstanceChild":true,"width":85.80531311035156,"height":59.88495635986328}],"Rectangle_20391":[{"name":"Rectangle_20391","relativeTransforms":[[1,0,4.022676944732666],[0,1,30.389385223388672]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":35.3053092956543,"height":27.707963943481445},{"name":"Rectangle_20391","relativeTransforms":[[1,0,4.02094841003418],[0,1,30.389385223388672]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":35.3053092956543,"height":27.707963943481445}],"Vector_202":[{"name":"Vector_202","relativeTransforms":[[1,0,21.451881408691406],[0,1,16.535402297973633]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":13.407079696655273,"height":7.597345352172852},{"name":"Vector_202","relativeTransforms":[[0.9175035953521729,0.3977274000644684,14.264795303344727],[-0.3977274000644684,0.9175035953521729,12.929712295532227]],"rotation":23.436184788007257,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":13.407079696655273,"height":7.597345352172852}],"Vector_203":[{"name":"Vector_203","relativeTransforms":[[-1,0,21.89878273010254],[0,1,16.535402297973633]],"rotation":-180,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":13.407079696655273,"height":7.597345352172852},{"name":"Vector_203","relativeTransforms":[[-0.9175035953521729,0.3977274000644684,14.67503833770752],[0.3977274000644684,0.9175035953521729,12.751786231994629]],"rotation":-156.56381521199276,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":13.407079696655273,"height":7.597345352172852}],"Subtract":[{"name":"Subtract","relativeTransforms":[[1,0,16.535951614379883],[0,1,30.389385223388672]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":9.83185863494873,"height":17.75012969970703},{"name":"Subtract","relativeTransforms":[[1,0,16.534223556518555],[0,1,30.389385223388672]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":9.83185863494873,"height":17.75012969970703}],"Top":[{"name":"Top","relativeTransforms":[[1,0,1.3412610292434692],[0,1,23.68584442138672]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":40.22123718261719,"height":8.938053131103516},{"name":"Top","relativeTransforms":[[1,0,-0.6383607387542725],[0,1,12.195448875427246]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":39.05039978027344,"height":22.790143966674805}],"Star_201":[{"name":"Star_201","relativeTransforms":[[1,0,31.730642318725586],[0,1,30.836286544799805]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":0.8938053250312805,"height":0.8938053250312805},{"name":"Star_201","relativeTransforms":[[0.9233025312423706,-0.38407349586486816,40.9296875],[0.38407349586486816,0.9233025312423706,18.1719970703125]],"rotation":-22.58623362027777,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":4.915929317474365,"height":6.256637096405029}],"Star_202":[{"name":"Star_202","relativeTransforms":[[1,0,31.730642318725586],[0,1,30.836286544799805]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":0.8938053250312805,"height":0.8938053250312805},{"name":"Star_202","relativeTransforms":[[0.9170909523963928,-0.3986780047416687,49.66015625],[0.3986780047416687,0.9170909523963928,19.440673828125]],"rotation":-23.49556056801255,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":4.915929317474365,"height":4.915929317474365}],"Star_203":[{"name":"Star_203","relativeTransforms":[[1,0,31.730642318725586],[0,1,30.836286544799805]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":1.3407080173492432,"height":1.3407080173492432},{"name":"Star_203","relativeTransforms":[[0.900789201259613,-0.4342566728591919,47.8203125],[0.4342566728591919,0.900789201259613,23.860015869140625]],"rotation":-25.738003653363478,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":7.597345352172852,"height":7.597345352172852}],"Star_204":[{"name":"Star_204","relativeTransforms":[[1,0,31.730642318725586],[0,1,30.836286544799805]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":1.3407080173492432,"height":1.3407080173492432},{"name":"Star_204","relativeTransforms":[[0.7071067690849304,-0.7071067690849304,46.21484375],[0.7071067690849304,0.7071067690849304,10.571990966796875]],"rotation":-45,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":8.938053131103516,"height":7.597345352172852}],"IMP_BLUE":[{"name":"IMP_BLUE","relativeTransforms":[[1,0,-39720.9375],[0,1,-417.93804931640625]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":200,"height":21.428571701049805},{"name":"IMP_BLUE","relativeTransforms":[[1,0,-39537],[0,1,-814]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":200,"height":21.428571701049805},{"name":"IMP_BLUE","relativeTransforms":[[1,0,-39537],[0,1,-814]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":200,"height":21.428571701049805}],"MASKED_20CONFIG":[{"name":"MASKED_20CONFIG","relativeTransforms":[[1,0,-39720.9375],[0,1,-417.93804931640625]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":200,"height":21.428571701049805},{"name":"MASKED_20CONFIG","relativeTransforms":[[1,0,-39537],[0,1,-814]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":200,"height":21.428571701049805},{"name":"MASKED_20CONFIG","relativeTransforms":[[1,0,-39537],[0,1,-814]],"rotation":0,"instanceParentName":"PromotionNotice_20Master","isInstanceParent":false,"isInstanceChild":true,"width":200,"height":21.428571701049805}]},"morph":{"condition":"props.morph","targets":{"Open=false":{"type":"ease","duration":500,"delay":2000},"Open=true":{"type":"ease","duration":500,"delay":0}},"numStates":2},"tProps":{"type":"PROPS","morph?":"number","maxSegmentLength?":"number","Open?":"\"false\" | \"true\"","onAnimationComplete?":"() => void"},"#discount":{"type":"SELECTOR","constraint":"xMinYMin meet","width":79,"height":25},"#Line_2017":{"type":"SELECTOR","constraint":"xMinYMin meet","width":17,"height":0},"#Line_2018":{"type":"SELECTOR","constraint":"xMinYMin meet","width":17,"height":0},"#baackground":{"type":"SELECTOR","constraint":"xMinYMin meet","width":651,"height":166},"#dash2":{"type":"SELECTOR","constraint":"xMinYMin meet","width":17,"height":0},"#dash1":{"type":"SELECTOR","constraint":"xMinYMin meet","width":17,"height":0},"#myPromotionCopy":{"type":"SELECTOR","constraint":"xMinYMin meet","width":455,"height":50},"#PromotionNotice":{"type":"SELECTOR","constraint":"xMinYMin meet","width":691,"height":389},"#PromotionNotice_20Master":{"type":"SELECTOR","constraint":"none","width":651,"height":166},"#myDiscount":{"type":"SELECTOR","constraint":"xMinYMin meet","width":80,"height":46},"#myRestrictions":{"type":"SELECTOR","constraint":"xMinYMin meet","width":373,"height":24},"#myDiscountCode":{"type":"SELECTOR","constraint":"xMinYMin meet","width":314,"height":33}}</desc>
 * <g id="Open=false">
 * <g id="PromotionNotice Master">
 * <rect id="baackground" x="1.1106" y="0.5" width="650" height="165" fill="#F1F1F1" stroke="#EDD4CB"/>
 * <text id="discount" fill="#4F4F4F" xml:space="preserve" style="white-space: pre" font-family="Poppins" font-size="14" font-weight="300" letter-spacing="0.02em"><tspan x="61.7867" y="130.4">off</tspan></text>
 * <line id="dash2" x1="88.6106" y1="124.5" x2="105.611" y2="124.5" stroke="#4F4F4F"/>
 * <line id="dash1" x1="36.6106" y1="124.5" x2="53.6106" y2="124.5" stroke="#4F4F4F"/>
 * <text id="myPromotionCopy" fill="#373938" xml:space="preserve" style="white-space: pre" font-family="Poppins" font-size="14" font-weight="300" letter-spacing="0.02em"><tspan x="135.611" y="100.4">Text that will appear on your landing page and    in other </tspan><tspan x="135.611" y="125.4">places with your customers.</tspan></text>
 * <text id="myDiscountCode" fill="#373938" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="28" font-weight="500" letter-spacing="0.03em"><tspan x="135.611" y="64.884">Christmas Sale 2021</tspan></text>
 * <text id="myDiscount" fill="#373938" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="32" font-weight="500" letter-spacing="0.03em"><tspan x="28.9987" y="106.296">$200</tspan></text>
 * <text id="myRestrictions" fill="#717171" xml:space="preserve" style="white-space: pre" font-family="Poppins" font-size="14" font-weight="600" letter-spacing="0.02em"><tspan x="323.537" y="155.9">ENDS:  December 25, Minimum Order: $500</tspan></text>
 * <g id="MagicBox">
 * <rect id="Rectangle 391" x="54.7506" y="47.5067" width="33.0708" height="25.4734" rx="1.11726" fill="#F1F1F1" stroke="black" stroke-width="2.23451"/>
 * <path id="Vector 2" d="M71.0625 40.1292C75.7159 36.1108 80.8125 29.3625 83.6932 34.2356C87.3831 40.4775 77.0455 40.1292 71.0625 40.1292Z" fill="#F1F1F1" stroke="black" stroke-width="2.23451" stroke-linejoin="round"/>
 * <path id="Vector 3" d="M71.5094 40.1292C66.856 36.1108 61.7594 29.3625 58.8787 34.2356C55.1888 40.4775 65.5264 40.1292 71.5094 40.1292Z" fill="#F1F1F1" stroke="black" stroke-width="2.23451" stroke-linejoin="round"/>
 * <path id="Subtract" d="M67.2639 61.3554V47.5067H74.8612V61.4068L72.4421 58.9429C71.6474 58.1334 70.3399 58.14 69.5543 58.9611L67.2639 61.3554ZM75.2441 61.7968L75.2438 61.7965L75.2441 61.7968Z" stroke="black" stroke-width="2.23451" stroke-linejoin="round"/>
 * <path id="Top" d="M53.1864 40.803H88.9386C89.5557 40.803 90.0559 41.3033 90.0559 41.9203V46.3893C90.0559 47.0064 89.5557 47.5066 88.9386 47.5066H53.1864C52.5694 47.5066 52.0692 47.0064 52.0692 46.3893V41.9203C52.0692 41.3033 52.5694 40.803 53.1864 40.803Z" fill="#F1F1F1" stroke="black" stroke-width="2.23451"/>
 * <path id="Star 1" d="M81.7069 47.0861C81.7325 47.0075 81.8437 47.0075 81.8693 47.0861V47.0861C81.8807 47.1213 81.9135 47.1451 81.9504 47.1451V47.1451C82.0331 47.1451 82.0675 47.2509 82.0006 47.2995V47.2995C81.9707 47.3212 81.9582 47.3598 81.9696 47.3949V47.3949C81.9951 47.4736 81.9051 47.539 81.8383 47.4904V47.4904C81.8083 47.4686 81.7678 47.4686 81.7379 47.4904V47.4904C81.671 47.539 81.581 47.4736 81.6066 47.3949V47.3949C81.618 47.3598 81.6055 47.3212 81.5756 47.2995V47.2995C81.5087 47.2509 81.5431 47.1451 81.6257 47.1451V47.1451C81.6627 47.1451 81.6955 47.1213 81.7069 47.0861V47.0861Z" fill="black"/>
 * <path id="Star 2" d="M81.7069 47.0861C81.7325 47.0075 81.8437 47.0075 81.8693 47.0861V47.0861C81.8807 47.1213 81.9135 47.1451 81.9504 47.1451V47.1451C82.0331 47.1451 82.0675 47.2509 82.0006 47.2995V47.2995C81.9707 47.3212 81.9582 47.3598 81.9696 47.3949V47.3949C81.9951 47.4736 81.9051 47.539 81.8383 47.4904V47.4904C81.8083 47.4686 81.7678 47.4686 81.7379 47.4904V47.4904C81.671 47.539 81.581 47.4736 81.6066 47.3949V47.3949C81.618 47.3598 81.6055 47.3212 81.5756 47.2995V47.2995C81.5087 47.2509 81.5431 47.1451 81.6257 47.1451V47.1451C81.6627 47.1451 81.6955 47.1213 81.7069 47.0861V47.0861Z" fill="black"/>
 * <path id="Star 3" d="M81.8898 47.211C81.9281 47.0931 82.095 47.0931 82.1333 47.211V47.211C82.1504 47.2638 82.1996 47.2995 82.2551 47.2995V47.2995C82.3791 47.2995 82.4306 47.4582 82.3303 47.5311V47.5311C82.2854 47.5637 82.2667 47.6215 82.2838 47.6742V47.6742C82.3221 47.7922 82.1871 47.8903 82.0868 47.8174V47.8174C82.0419 47.7848 81.9812 47.7848 81.9363 47.8174V47.8174C81.836 47.8903 81.701 47.7922 81.7393 47.6742V47.6742C81.7564 47.6215 81.7376 47.5637 81.6928 47.5311V47.5311C81.5924 47.4582 81.644 47.2995 81.768 47.2995V47.2995C81.8235 47.2995 81.8726 47.2638 81.8898 47.211V47.211Z" fill="black"/>
 * <path id="Star 4" d="M81.8898 47.211C81.9281 47.0931 82.095 47.0931 82.1333 47.211V47.211C82.1504 47.2638 82.1996 47.2995 82.2551 47.2995V47.2995C82.3791 47.2995 82.4306 47.4582 82.3303 47.5311V47.5311C82.2854 47.5637 82.2667 47.6215 82.2838 47.6742V47.6742C82.3221 47.7922 82.1871 47.8903 82.0868 47.8174V47.8174C82.0419 47.7848 81.9812 47.7848 81.9363 47.8174V47.8174C81.836 47.8903 81.701 47.7922 81.7393 47.6742V47.6742C81.7564 47.6215 81.7376 47.5637 81.6928 47.5311V47.5311C81.5924 47.4582 81.644 47.2995 81.768 47.2995V47.2995C81.8235 47.2995 81.8726 47.2638 81.8898 47.211V47.211Z" fill="black"/>
 * </g>
 * </g>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * MORPH TARGET - STATE 1
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="651" height="170" viewBox="0 0 651 170" fill="none">
 * <g id="Open=true">
 * <g id="PromotionNotice Master">
 * <rect id="baackground" x="0.5" y="0.5" width="650" height="165" fill="#F1F1F1" stroke="#EDD4CB"/>
 * <text id="discount" fill="#4F4F4F" xml:space="preserve" style="white-space: pre" font-family="Poppins" font-size="14" font-weight="300" letter-spacing="0.02em"><tspan x="61.1761" y="130.4">off</tspan></text>
 * <line id="dash2" x1="88" y1="124.5" x2="105" y2="124.5" stroke="#4F4F4F"/>
 * <line id="dash1" x1="36" y1="124.5" x2="53" y2="124.5" stroke="#4F4F4F"/>
 * <text id="myPromotionCopy" fill="#373938" xml:space="preserve" style="white-space: pre" font-family="Poppins" font-size="14" font-weight="300" letter-spacing="0.02em"><tspan x="135" y="100.4">Text that will appear on your landing page and    in other </tspan><tspan x="135" y="125.4">places with your customers.</tspan></text>
 * <text id="myDiscountCode" fill="#373938" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="28" font-weight="500" letter-spacing="0.03em"><tspan x="135" y="64.884">Christmas Sale 2021</tspan></text>
 * <text id="myDiscount" fill="#373938" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="32" font-weight="500" letter-spacing="0.03em"><tspan x="28.3881" y="106.296">$200</tspan></text>
 * <text id="myRestrictions" fill="#717171" xml:space="preserve" style="white-space: pre" font-family="Poppins" font-size="14" font-weight="600" letter-spacing="0.02em"><tspan x="322.926" y="155.9">ENDS:  December 25, Minimum Order: $500</tspan></text>
 * <g id="MagicBox">
 * <rect id="Rectangle 391" x="54.1383" y="47.5067" width="33.0708" height="25.4734" rx="1.11726" fill="#F1F1F1" stroke="black" stroke-width="2.23451"/>
 * <path id="Star 1" d="M91.1479 36.5157C91.4258 36.1456 92.014 36.3902 91.9475 36.8483L91.9283 36.9801C91.899 37.1823 92.0104 37.3786 92.199 37.457L92.4733 37.5711C92.8487 37.7273 92.8374 38.263 92.4558 38.4032L91.9301 38.5964C91.7761 38.6529 91.6655 38.7893 91.642 38.9516L91.577 39.399C91.513 39.8397 90.9143 39.9259 90.7286 39.5212L90.7111 39.4831C90.6138 39.2711 90.3698 39.1696 90.1508 39.2501L90.1115 39.2645C89.6935 39.4181 89.3326 38.9327 89.6 38.5767L89.8715 38.2151C89.97 38.084 89.9888 37.9094 89.9203 37.7603L89.6867 37.2514C89.5171 36.8818 89.8891 36.4962 90.2645 36.6523L90.5389 36.7665C90.7274 36.8449 90.9452 36.7855 91.0679 36.6222L91.1479 36.5157Z" fill="black"/>
 * <path id="Star 2" d="M100.003 37.4508C100.29 37.1265 100.824 37.3588 100.783 37.7897L100.774 37.875C100.756 38.0677 100.864 38.2505 101.041 38.3277L101.12 38.3618C101.517 38.5344 101.461 39.1142 101.038 39.208L100.955 39.2265C100.766 39.2685 100.625 39.4273 100.607 39.62L100.598 39.7053C100.557 40.1363 99.9882 40.2624 99.7684 39.8894L99.7249 39.8156C99.6266 39.6487 99.4321 39.5642 99.2431 39.6061L99.1594 39.6247C98.7368 39.7184 98.4411 39.2165 98.7279 38.8923L98.7847 38.8281C98.913 38.6831 98.9333 38.4719 98.835 38.3051L98.7915 38.2313C98.5718 37.8583 98.9577 37.422 99.3548 37.5946L99.4333 37.6288C99.6109 37.7059 99.818 37.66 99.9462 37.515L100.003 37.4508Z" fill="black"/>
 * <path id="Star 3" d="M99.2912 42.5035C99.5905 42.1907 100.115 42.4436 100.057 42.8726L99.9142 43.9227C99.8882 44.1146 99.9886 44.3014 100.163 44.3855L101.118 44.8457C101.508 45.0337 101.429 45.6109 101.003 45.688L99.9604 45.8768C99.7698 45.9113 99.6232 46.0645 99.5971 46.2564L99.4544 47.3065C99.3962 47.7355 98.823 47.8393 98.618 47.458L98.1162 46.5245C98.0245 46.354 97.8334 46.2619 97.6429 46.2964L96.6001 46.4852C96.1741 46.5623 95.8983 46.0492 96.1976 45.7364L96.9303 44.9707C97.0641 44.8309 97.0927 44.6207 97.001 44.4502L96.4992 43.5167C96.2942 43.1354 96.6969 42.7145 97.0869 42.9025L98.0415 43.3628C98.2159 43.4468 98.4247 43.409 98.5585 43.2692L99.2912 42.5035Z" fill="black"/>
 * <path id="Star 4" d="M97.3076 30.2091C97.682 30.0418 98.0653 30.425 97.8979 30.7995L97.3539 32.0168C97.2783 32.1859 97.3149 32.3841 97.4459 32.5151L98.4112 33.4804C98.7296 33.7988 98.4305 34.3349 97.9924 34.2313L96.8797 33.9683C96.6709 33.9189 96.4564 34.0249 96.3689 34.2208L95.9122 35.2427C95.7378 35.6329 95.1676 35.5791 95.0693 35.1631L94.7264 33.7127C94.6874 33.5481 94.5589 33.4196 94.3943 33.3807L92.9439 33.0377C92.5279 32.9394 92.4741 32.3692 92.8644 32.1948L93.8862 31.7382C94.0821 31.6506 94.1881 31.4362 94.1387 31.2273L93.8757 30.1147C93.7721 29.6765 94.3082 29.3775 94.6266 29.6958L95.5919 30.6611C95.7229 30.7921 95.9211 30.8287 96.0903 30.7531L97.3076 30.2091Z" fill="black"/>
 * <path id="Vector 2" d="M66.285 35.8971C68.9563 30.3593 70.9485 22.1407 75.5297 25.466C81.3978 29.7254 71.7744 33.5175 66.285 35.8971Z" fill="#F1F1F1" stroke="black" stroke-width="2.23451" stroke-linejoin="round"/>
 * <path id="Vector 3" d="M66.6953 35.7191C60.8276 33.883 53.4674 29.7184 52.7625 35.3352C51.8596 42.5298 61.2059 38.0987 66.6953 35.7191Z" fill="#F1F1F1" stroke="black" stroke-width="2.23451" stroke-linejoin="round"/>
 * <path id="Subtract" d="M66.6514 61.3554V47.5067H74.2488V61.4068L71.8296 58.9429C71.0349 58.1334 69.7274 58.14 68.9418 58.9611L66.6514 61.3554ZM74.6317 61.7968L74.6314 61.7965L74.6317 61.7968Z" stroke="black" stroke-width="2.23451" stroke-linejoin="round"/>
 * <path id="Top" d="M50.1524 43.6252L82.9552 29.4056C83.5213 29.1601 84.1792 29.4201 84.4246 29.9863L86.2021 34.0866C86.4475 34.6528 86.1875 35.3107 85.6214 35.5561L52.8186 49.7757C52.2525 50.0211 51.5946 49.7611 51.3491 49.195L49.5717 45.0946C49.3263 44.5285 49.5863 43.8706 50.1524 43.6252Z" fill="#F1F1F1" stroke="black" stroke-width="2.23451"/>
 * </g>
 * </g>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {
 * 	"#Open_3Dfalse": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 651,
 * 		"height": 166
 * 	},
 * 	"#Rectangle_20390": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 651,
 * 		"height": 166
 * 	},
 * 	"#MagicBox": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 85.80531311035156,
 * 		"height": 59.88495635986328
 * 	},
 * 	"#Rectangle_20391": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 35.3053092956543,
 * 		"height": 27.707963943481445
 * 	},
 * 	"#Vector_202": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 13.407079696655273,
 * 		"height": 7.597345352172852
 * 	},
 * 	"#Vector_203": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 13.407079696655273,
 * 		"height": 7.597345352172852
 * 	},
 * 	"#Subtract": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 9.83185863494873,
 * 		"height": 17.75012969970703
 * 	},
 * 	"#Top": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 39.05039978027344,
 * 		"height": 22.790143966674805
 * 	},
 * 	"#Star_201": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 4.915929317474365,
 * 		"height": 6.256637096405029
 * 	},
 * 	"#Star_202": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 4.915929317474365,
 * 		"height": 4.915929317474365
 * 	},
 * 	"#Star_203": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 7.597345352172852,
 * 		"height": 7.597345352172852
 * 	},
 * 	"#Star_204": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 8.938053131103516,
 * 		"height": 7.597345352172852
 * 	},
 * 	"#Open_3Dtrue": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 651,
 * 		"height": 166
 * 	},
 * 	"transforms": {
 * 		"PromotionNotice_20Master": [
 * 			{
 * 				"name": "PromotionNotice_20Master",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						0
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						0
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": true,
 * 				"isInstanceChild": false,
 * 				"width": 651,
 * 				"height": 166
 * 			},
 * 			{
 * 				"name": "PromotionNotice_20Master",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						0
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						0
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": true,
 * 				"isInstanceChild": false,
 * 				"width": 651,
 * 				"height": 166
 * 			}
 * 		],
 * 		"baackground": [
 * 			{
 * 				"name": "baackground",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						0
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						-4
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 651,
 * 				"height": 166
 * 			},
 * 			{
 * 				"name": "baackground",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						0
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						-4
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 651,
 * 				"height": 166
 * 			}
 * 		],
 * 		"discount": [
 * 			{
 * 				"name": "discount",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						31
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						109
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 79,
 * 				"height": 25
 * 			},
 * 			{
 * 				"name": "discount",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						31
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						109
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 79,
 * 				"height": 25
 * 			}
 * 		],
 * 		"dash2": [
 * 			{
 * 				"name": "dash2",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						88
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						121
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 17,
 * 				"height": 0
 * 			},
 * 			{
 * 				"name": "dash2",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						88
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						121
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 17,
 * 				"height": 0
 * 			}
 * 		],
 * 		"dash1": [
 * 			{
 * 				"name": "dash1",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						36
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						121
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 17,
 * 				"height": 0
 * 			},
 * 			{
 * 				"name": "dash1",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						36
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						121
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 17,
 * 				"height": 0
 * 			}
 * 		],
 * 		"myPromotionCopy": [
 * 			{
 * 				"name": "myPromotionCopy",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						135
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						79
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 455,
 * 				"height": 50
 * 			},
 * 			{
 * 				"name": "myPromotionCopy",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						135
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						79
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 455,
 * 				"height": 50
 * 			}
 * 		],
 * 		"myDiscountCode": [
 * 			{
 * 				"name": "myDiscountCode",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						135
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						33
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 314,
 * 				"height": 33
 * 			},
 * 			{
 * 				"name": "myDiscountCode",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						135
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						33
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 314,
 * 				"height": 33
 * 			}
 * 		],
 * 		"myDiscount": [
 * 			{
 * 				"name": "myDiscount",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						28
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						68
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 80,
 * 				"height": 46
 * 			},
 * 			{
 * 				"name": "myDiscount",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						28
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						68
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 80,
 * 				"height": 46
 * 			}
 * 		],
 * 		"myRestrictions": [
 * 			{
 * 				"name": "myRestrictions",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						264
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						137
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 373,
 * 				"height": 24
 * 			},
 * 			{
 * 				"name": "myRestrictions",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						264
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						137
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 373,
 * 				"height": 24
 * 			}
 * 		],
 * 		"MagicBox": [
 * 			{
 * 				"name": "MagicBox",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						49
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						12
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": true,
 * 				"isInstanceChild": true,
 * 				"width": 85.80531311035156,
 * 				"height": 59.88495635986328
 * 			},
 * 			{
 * 				"name": "MagicBox",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						49
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						12
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": true,
 * 				"isInstanceChild": true,
 * 				"width": 85.80531311035156,
 * 				"height": 59.88495635986328
 * 			}
 * 		],
 * 		"Rectangle_20391": [
 * 			{
 * 				"name": "Rectangle_20391",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						4.022676944732666
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						30.389385223388672
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 35.3053092956543,
 * 				"height": 27.707963943481445
 * 			},
 * 			{
 * 				"name": "Rectangle_20391",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						4.02094841003418
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						30.389385223388672
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 35.3053092956543,
 * 				"height": 27.707963943481445
 * 			}
 * 		],
 * 		"Vector_202": [
 * 			{
 * 				"name": "Vector_202",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						21.451881408691406
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						16.535402297973633
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 13.407079696655273,
 * 				"height": 7.597345352172852
 * 			},
 * 			{
 * 				"name": "Vector_202",
 * 				"relativeTransforms": [
 * 					[
 * 						0.9175035953521729,
 * 						0.3977274000644684,
 * 						14.264795303344727
 * 					],
 * 					[
 * 						-0.3977274000644684,
 * 						0.9175035953521729,
 * 						12.929712295532227
 * 					]
 * 				],
 * 				"rotation": 23.436184788007257,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 13.407079696655273,
 * 				"height": 7.597345352172852
 * 			}
 * 		],
 * 		"Vector_203": [
 * 			{
 * 				"name": "Vector_203",
 * 				"relativeTransforms": [
 * 					[
 * 						-1,
 * 						0,
 * 						21.89878273010254
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						16.535402297973633
 * 					]
 * 				],
 * 				"rotation": -180,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 13.407079696655273,
 * 				"height": 7.597345352172852
 * 			},
 * 			{
 * 				"name": "Vector_203",
 * 				"relativeTransforms": [
 * 					[
 * 						-0.9175035953521729,
 * 						0.3977274000644684,
 * 						14.67503833770752
 * 					],
 * 					[
 * 						0.3977274000644684,
 * 						0.9175035953521729,
 * 						12.751786231994629
 * 					]
 * 				],
 * 				"rotation": -156.56381521199276,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 13.407079696655273,
 * 				"height": 7.597345352172852
 * 			}
 * 		],
 * 		"Subtract": [
 * 			{
 * 				"name": "Subtract",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						16.535951614379883
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						30.389385223388672
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 9.83185863494873,
 * 				"height": 17.75012969970703
 * 			},
 * 			{
 * 				"name": "Subtract",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						16.534223556518555
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						30.389385223388672
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 9.83185863494873,
 * 				"height": 17.75012969970703
 * 			}
 * 		],
 * 		"Top": [
 * 			{
 * 				"name": "Top",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						1.3412610292434692
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						23.68584442138672
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 40.22123718261719,
 * 				"height": 8.938053131103516
 * 			},
 * 			{
 * 				"name": "Top",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						-0.6383607387542725
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						12.195448875427246
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 39.05039978027344,
 * 				"height": 22.790143966674805
 * 			}
 * 		],
 * 		"Star_201": [
 * 			{
 * 				"name": "Star_201",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						31.730642318725586
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						30.836286544799805
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 0.8938053250312805,
 * 				"height": 0.8938053250312805
 * 			},
 * 			{
 * 				"name": "Star_201",
 * 				"relativeTransforms": [
 * 					[
 * 						0.9233025312423706,
 * 						-0.38407349586486816,
 * 						40.9296875
 * 					],
 * 					[
 * 						0.38407349586486816,
 * 						0.9233025312423706,
 * 						18.1719970703125
 * 					]
 * 				],
 * 				"rotation": -22.58623362027777,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 4.915929317474365,
 * 				"height": 6.256637096405029
 * 			}
 * 		],
 * 		"Star_202": [
 * 			{
 * 				"name": "Star_202",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						31.730642318725586
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						30.836286544799805
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 0.8938053250312805,
 * 				"height": 0.8938053250312805
 * 			},
 * 			{
 * 				"name": "Star_202",
 * 				"relativeTransforms": [
 * 					[
 * 						0.9170909523963928,
 * 						-0.3986780047416687,
 * 						49.66015625
 * 					],
 * 					[
 * 						0.3986780047416687,
 * 						0.9170909523963928,
 * 						19.440673828125
 * 					]
 * 				],
 * 				"rotation": -23.49556056801255,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 4.915929317474365,
 * 				"height": 4.915929317474365
 * 			}
 * 		],
 * 		"Star_203": [
 * 			{
 * 				"name": "Star_203",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						31.730642318725586
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						30.836286544799805
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 1.3407080173492432,
 * 				"height": 1.3407080173492432
 * 			},
 * 			{
 * 				"name": "Star_203",
 * 				"relativeTransforms": [
 * 					[
 * 						0.900789201259613,
 * 						-0.4342566728591919,
 * 						47.8203125
 * 					],
 * 					[
 * 						0.4342566728591919,
 * 						0.900789201259613,
 * 						23.860015869140625
 * 					]
 * 				],
 * 				"rotation": -25.738003653363478,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 7.597345352172852,
 * 				"height": 7.597345352172852
 * 			}
 * 		],
 * 		"Star_204": [
 * 			{
 * 				"name": "Star_204",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						31.730642318725586
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						30.836286544799805
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 1.3407080173492432,
 * 				"height": 1.3407080173492432
 * 			},
 * 			{
 * 				"name": "Star_204",
 * 				"relativeTransforms": [
 * 					[
 * 						0.7071067690849304,
 * 						-0.7071067690849304,
 * 						46.21484375
 * 					],
 * 					[
 * 						0.7071067690849304,
 * 						0.7071067690849304,
 * 						10.571990966796875
 * 					]
 * 				],
 * 				"rotation": -45,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 8.938053131103516,
 * 				"height": 7.597345352172852
 * 			}
 * 		],
 * 		"IMP_BLUE": [
 * 			{
 * 				"name": "IMP_BLUE",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						-39720.9375
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						-417.93804931640625
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 200,
 * 				"height": 21.428571701049805
 * 			},
 * 			{
 * 				"name": "IMP_BLUE",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						-39537
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						-814
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 200,
 * 				"height": 21.428571701049805
 * 			},
 * 			{
 * 				"name": "IMP_BLUE",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						-39537
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						-814
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 200,
 * 				"height": 21.428571701049805
 * 			}
 * 		],
 * 		"MASKED_20CONFIG": [
 * 			{
 * 				"name": "MASKED_20CONFIG",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						-39720.9375
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						-417.93804931640625
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 200,
 * 				"height": 21.428571701049805
 * 			},
 * 			{
 * 				"name": "MASKED_20CONFIG",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						-39537
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						-814
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 200,
 * 				"height": 21.428571701049805
 * 			},
 * 			{
 * 				"name": "MASKED_20CONFIG",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						-39537
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						-814
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "PromotionNotice_20Master",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 200,
 * 				"height": 21.428571701049805
 * 			}
 * 		]
 * 	},
 * 	"morph": {
 * 		"condition": "props.morph",
 * 		"targets": {
 * 			"Open=false": {
 * 				"type": "ease",
 * 				"duration": 500,
 * 				"delay": 2000
 * 			},
 * 			"Open=true": {
 * 				"type": "ease",
 * 				"duration": 500,
 * 				"delay": 0
 * 			}
 * 		},
 * 		"numStates": 2
 * 	},
 * 	"tProps": {
 * 		"type": "PROPS",
 * 		"morph?": "number",
 * 		"maxSegmentLength?": "number",
 * 		"Open?": "\"false\" | \"true\"",
 * 		"onAnimationComplete?": "() => void"
 * 	},
 * 	"#discount": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 79,
 * 		"height": 25
 * 	},
 * 	"#Line_2017": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 17,
 * 		"height": 0
 * 	},
 * 	"#Line_2018": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 17,
 * 		"height": 0
 * 	},
 * 	"#baackground": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 651,
 * 		"height": 166
 * 	},
 * 	"#dash2": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 17,
 * 		"height": 0
 * 	},
 * 	"#dash1": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 17,
 * 		"height": 0
 * 	},
 * 	"#myPromotionCopy": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 455,
 * 		"height": 50
 * 	},
 * 	"#PromotionNotice": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 691,
 * 		"height": 389
 * 	},
 * 	"#PromotionNotice_20Master": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 651,
 * 		"height": 166
 * 	},
 * 	"#myDiscount": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 80,
 * 		"height": 46
 * 	},
 * 	"#myRestrictions": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 373,
 * 		"height": 24
 * 	},
 * 	"#myDiscountCode": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 314,
 * 		"height": 33
 * 	}
 * }
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  hasDelay?: boolean;
  morph?: number;
  maxSegmentLength?: number;
  Open?: "false" | "true";
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/** Morphing Types */

type tReactRefUnknown = React.Ref<React.Component<unknown, unknown, unknown>>;
type tMorphRef = Animated.WithAnimatedValue<tReactRefUnknown> & tReactRefUnknown;
type tPathRef = typeof Path & {
  // Native Control
  setNativeProps: ({ d, matrix }: { d?: string; matrix?: number[] }) => void; // Web Control

  _touchableNode: {
    setAttribute: (attr: string, val: string) => void;
  }; // Get Ids

  props: {
    id: string;
  };
};
type tMorphProps = {
  morphConfigbaackgroundd: string | number | Animated.AnimatedInterpolation;
  morphConfigdiscount_elem0x: string | number | Animated.AnimatedInterpolation;
  morphConfigdash2d: string | number | Animated.AnimatedInterpolation;
  morphConfigdash1d: string | number | Animated.AnimatedInterpolation;
  morphConfigmyPromotionCopy_elem0x: string | number | Animated.AnimatedInterpolation;
  morphConfigmyPromotionCopy_elem1x: string | number | Animated.AnimatedInterpolation;
  morphConfigmyDiscountCode_elem0x: string | number | Animated.AnimatedInterpolation;
  morphConfigmyDiscount_elem0x: string | number | Animated.AnimatedInterpolation;
  morphConfigmyRestrictions_elem0x: string | number | Animated.AnimatedInterpolation;
  morphConfigRectangle_20391d: string | number | Animated.AnimatedInterpolation;
  morphConfigVector_202d: string | number | Animated.AnimatedInterpolation;
  morphConfigVector_203d: string | number | Animated.AnimatedInterpolation;
  morphConfigSubtractd: string | number | Animated.AnimatedInterpolation;
  morphConfigTopd: string | number | Animated.AnimatedInterpolation;
  morphConfigStar_201d: string | number | Animated.AnimatedInterpolation;
  morphConfigStar_202d: string | number | Animated.AnimatedInterpolation;
  morphConfigStar_203d: string | number | Animated.AnimatedInterpolation;
  morphConfigStar_204d: string | number | Animated.AnimatedInterpolation;
  bindInterpolation: tMorphRef;
};
/***/

/** Convenience for prop insertion from ast (no-color-literals/no-inline-styles) */

/* eslint-disable react-native/no-color-literals */

/* eslint-disable react-native/no-inline-styles */

/** Local Styles */

const kLocalStyles = StyleSheet.create({
  kOverlay: {
    left: 0,
    position: "absolute",
    top: 0,
  },
});
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const PromotionNotice = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  hasDelay?: boolean;
  morph?: number;
  myDiscount: string;
  myDiscountRestrictions: string;
  myDiscountCode: string;
  myDiscountCopy: string;
  maxSegmentLength?: number;
  Open?: "false" | "true";
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const {
    style = {
      width: 652,
      height: 170,
    },
    svgStyle = {
      width: "100%",
      height: "100%",
    },
    svgRef,
  } = props;

  function checkFont(myStrFamily: string) {
    let aReturnFamily;

    if (FontList) {
      FontList.get((fontFamilies: Array<string>) => {
        if (fontFamilies.includes(myStrFamily)) {
          aReturnFamily = myStrFamily;
        } else {
          console.warn(`"${myStrFamily}" is not a valid font. Using "${fontFamilies[0]}" instead. `);
          aReturnFamily = fontFamilies[0];
        }
      });
    } else {
      aReturnFamily = myStrFamily;
    }

    return aReturnFamily;
  }

  /** Component Internal State */

  const [morphState] = React.useState<{
    morphAnimVal: Animated.Value;
    morphProps: tMorphProps;
  }>({
    morphAnimVal: new Animated.Value(0),
    morphProps: {
      bindInterpolation: () => undefined,
      morphConfigbaackgroundd:
        "M1.1106 0.5 H651.1106 a0,0 0 0 1 0,0 V165.5 a0,0 0 0 1 -0,0 H1.1106 a0,0 0 0 1 -0,-0 V0.5 a0,0 0 0 1 0,-0z",
      morphConfigdiscount_elem0x: 61.7867,
      morphConfigdash2d: "M88.6106 124.5 L105.611 124.5 M88.6106 105.611z",
      morphConfigdash1d: "M36.6106 124.5 L53.6106 124.5 M36.6106 53.6106z",
      morphConfigmyPromotionCopy_elem0x: 135.611,
      morphConfigmyPromotionCopy_elem1x: 135.611,
      morphConfigmyDiscountCode_elem0x: 135.611,
      morphConfigmyDiscount_elem0x: 28.9987,
      morphConfigmyRestrictions_elem0x: 323.537,
      morphConfigRectangle_20391d:
        "M55.86786 47.5067 H86.70414 a1.11726,1.11726 0 0 1 1.11726,1.11726 V71.86284 a1.11726,1.11726 0 0 1 -1.11726,1.11726 H55.86786 a1.11726,1.11726 0 0 1 -1.11726,-1.11726 V48.623960000000004 a1.11726,1.11726 0 0 1 1.11726,-1.11726z",
      morphConfigVector_202d:
        "M71.0625 40.1292C75.7159 36.1108 80.8125 29.3625 83.6932 34.2356C87.3831 40.4775 77.0455 40.1292 71.0625 40.1292Z",
      morphConfigVector_203d:
        "M71.5094 40.1292C66.856 36.1108 61.7594 29.3625 58.8787 34.2356C55.1888 40.4775 65.5264 40.1292 71.5094 40.1292Z",
      morphConfigSubtractd:
        "M67.2639 61.3554V47.5067H74.8612V61.4068L72.4421 58.9429C71.6474 58.1334 70.3399 58.14 69.5543 58.9611L67.2639 61.3554ZM75.2441 61.7968L75.2438 61.7965L75.2441 61.7968Z",
      morphConfigTopd:
        "M53.1864 40.803H88.9386C89.5557 40.803 90.0559 41.3033 90.0559 41.9203V46.3893C90.0559 47.0064 89.5557 47.5066 88.9386 47.5066H53.1864C52.5694 47.5066 52.0692 47.0064 52.0692 46.3893V41.9203C52.0692 41.3033 52.5694 40.803 53.1864 40.803Z",
      morphConfigStar_201d:
        "M81.7069 47.0861C81.7325 47.0075 81.8437 47.0075 81.8693 47.0861V47.0861C81.8807 47.1213 81.9135 47.1451 81.9504 47.1451V47.1451C82.0331 47.1451 82.0675 47.2509 82.0006 47.2995V47.2995C81.9707 47.3212 81.9582 47.3598 81.9696 47.3949V47.3949C81.9951 47.4736 81.9051 47.539 81.8383 47.4904V47.4904C81.8083 47.4686 81.7678 47.4686 81.7379 47.4904V47.4904C81.671 47.539 81.581 47.4736 81.6066 47.3949V47.3949C81.618 47.3598 81.6055 47.3212 81.5756 47.2995V47.2995C81.5087 47.2509 81.5431 47.1451 81.6257 47.1451V47.1451C81.6627 47.1451 81.6955 47.1213 81.7069 47.0861V47.0861Z",
      morphConfigStar_202d:
        "M81.7069 47.0861C81.7325 47.0075 81.8437 47.0075 81.8693 47.0861V47.0861C81.8807 47.1213 81.9135 47.1451 81.9504 47.1451V47.1451C82.0331 47.1451 82.0675 47.2509 82.0006 47.2995V47.2995C81.9707 47.3212 81.9582 47.3598 81.9696 47.3949V47.3949C81.9951 47.4736 81.9051 47.539 81.8383 47.4904V47.4904C81.8083 47.4686 81.7678 47.4686 81.7379 47.4904V47.4904C81.671 47.539 81.581 47.4736 81.6066 47.3949V47.3949C81.618 47.3598 81.6055 47.3212 81.5756 47.2995V47.2995C81.5087 47.2509 81.5431 47.1451 81.6257 47.1451V47.1451C81.6627 47.1451 81.6955 47.1213 81.7069 47.0861V47.0861Z",
      morphConfigStar_203d:
        "M81.8898 47.211C81.9281 47.0931 82.095 47.0931 82.1333 47.211V47.211C82.1504 47.2638 82.1996 47.2995 82.2551 47.2995V47.2995C82.3791 47.2995 82.4306 47.4582 82.3303 47.5311V47.5311C82.2854 47.5637 82.2667 47.6215 82.2838 47.6742V47.6742C82.3221 47.7922 82.1871 47.8903 82.0868 47.8174V47.8174C82.0419 47.7848 81.9812 47.7848 81.9363 47.8174V47.8174C81.836 47.8903 81.701 47.7922 81.7393 47.6742V47.6742C81.7564 47.6215 81.7376 47.5637 81.6928 47.5311V47.5311C81.5924 47.4582 81.644 47.2995 81.768 47.2995V47.2995C81.8235 47.2995 81.8726 47.2638 81.8898 47.211V47.211Z",
      morphConfigStar_204d:
        "M81.8898 47.211C81.9281 47.0931 82.095 47.0931 82.1333 47.211V47.211C82.1504 47.2638 82.1996 47.2995 82.2551 47.2995V47.2995C82.3791 47.2995 82.4306 47.4582 82.3303 47.5311V47.5311C82.2854 47.5637 82.2667 47.6215 82.2838 47.6742V47.6742C82.3221 47.7922 82.1871 47.8903 82.0868 47.8174V47.8174C82.0419 47.7848 81.9812 47.7848 81.9363 47.8174V47.8174C81.836 47.8903 81.701 47.7922 81.7393 47.6742V47.6742C81.7564 47.6215 81.7376 47.5637 81.6928 47.5311V47.5311C81.5924 47.4582 81.644 47.2995 81.768 47.2995V47.2995C81.8235 47.2995 81.8726 47.2638 81.8898 47.211V47.211Z",
    },
  });
  /** End Custom React-Hooks */

  /** Morph Wrapper */

  type tMorphProperty = {
    Open: "false" | "true";
  };
  type tMorphProperties = {
    [key: string]: tMorphProperty;
  };
  const morphStates: tMorphProperties = {
    0: {
      Open: "false",
    },
    1: {
      Open: "true",
    },
  };

  function getNextMorphState(): number {
    const { Open, morph = 0 } = props;
    let nextState = morph;
    Object.keys(morphStates).forEach((possibleMorphState) => {
      if (morphStates[possibleMorphState].Open === Open) {
        nextState = parseInt(possibleMorphState, 10);
      }
    });
    return nextState;
  }

  const { morphAnimVal, morphProps } = morphState;
  const maxSegmentLength = props?.maxSegmentLength ?? 1;

  const onAnimationComplete: () => void = props?.onAnimationComplete ?? (() => 0);

  const currValueRef = React.useRef(0);
  const nextValue: number = getNextMorphState() ?? 1;
  const currValue = currValueRef.current;
  let startValue = Math.floor(currValue);
  let endValue = Math.ceil(nextValue);

  if (currValue > nextValue) {
    startValue = Math.ceil(currValue);
    endValue = Math.floor(nextValue);
  }
  /**
   * Normalize an input to a range of 0 to 1
   */

  const normalize = (x: number, bound1: number, bound2: number) => {
    let result = 0;
    const aNumerator = x - Math.min(bound1, bound2);
    const aDenominator = Math.max(bound1, bound2) - Math.min(bound1, bound2);

    if (aDenominator !== 0) {
      result = aNumerator / aDenominator;
    }

    if (Number.isNaN(result)) {
      result = 0;
    }

    return result;
  };
  /**
   * Generates an interpolation function from 2 Matrices
   * This function will perform component-wise linear interpolation from matrix A to B at a given time value t
   */

  const interpolateMatrices = (m1: number[], m2: number[]) => {
    // linear interpolation
    const lerp = (x0: number, x1: number, t: number) => x0 * (1 - t) + x1 * t;

    return (t: number) => m1.map((x0, i) => lerp(x0, m2[i], t));
  };

  type tMorphInterpolation = {
    type: "Morph";
    morphId: keyof tMorphProps;
    paths: string[];
  };
  type tMatrixInterpolation = {
    type: "Matrix";
    morphId: keyof tMorphProps;
    matrices: number[][];
  };
  /**
   * Custom Hook to Control Animation Interpolation of SVG Paths
   */

  const useGenerateMorphInterpolation = (
    interpolations: Array<tMorphInterpolation | tMatrixInterpolation>,
    start: number,
    end: number,
  ) => {
    const refs = React.useRef<Record<string, tPathRef>>({});
    React.useEffect(() => {
      if (interpolations.length === 0) return () => 0;
      type tInterpolator = (t: number) => string;
      type tInterpolatorMorph = {
        type: "Normal" | "SubPath";
        interpolator: (t: number) => string;
      };
      type tInterpolatorMatrix = {
        type: "Matrix";
        interpolator: (t: number) => number[];
      };

      const toSubPaths = (myPath: string) =>
        String(myPath)
          .split(/m|M/)
          .filter((subPath) => Boolean(subPath))
          .map((subPath) => `M${subPath}${subPath.endsWith("Z") ? "" : "Z"}`);

      const interpolators: {
        [morphId: string]: tInterpolatorMorph | tInterpolatorMatrix;
      } = {};
      interpolations.forEach((interpolation) => {
        if (interpolation.type === "Morph") {
          const { morphId, paths } = interpolation;
          const initial = paths[start];
          const final = paths[end];
          const p1 = start > end ? final : initial;
          const p2 = start > end ? initial : final;
          const defaultInterpolator = interpolate(p1, p2, {
            maxSegmentLength,
          });
          const p1SubPaths = toSubPaths(p1);
          const p2SubPaths = toSubPaths(p2);
          const newSubPaths: tInterpolator[] = [];
          let type: tInterpolatorMorph["type"] = "Normal";

          if (p1SubPaths.length > 1 && p2SubPaths.length > 1 && p1SubPaths.length === p2SubPaths.length) {
            type = "SubPath";

            for (let i = 0; i < p1SubPaths.length; i += 1) {
              const subP1 = p1SubPaths[i];
              const subP2 = p2SubPaths[i];
              newSubPaths.push(
                interpolate(subP1, subP2, {
                  maxSegmentLength,
                }),
              );
            }
          }

          const interpolator = (t: number) => {
            if (type === "SubPath") {
              return `${newSubPaths.map((subInterpolator) => subInterpolator(t).replace(/z|Z/g, "")).join(" ")}Z`;
            }

            return defaultInterpolator(t);
          };

          interpolators[morphId] = {
            type,
            interpolator,
          };
        } else if (interpolation.type === "Matrix") {
          const { type, morphId, matrices } = interpolation;
          const initial = matrices[start];
          const final = matrices[end];
          const m1 = start > end ? final : initial;
          const m2 = start > end ? initial : final;
          const interpolator = interpolateMatrices(m1, m2);
          interpolators[morphId] = {
            type,
            interpolator,
          };
        }
      });

      const onValueChange = ({ value }: { value: number }) => {
        Object.entries(interpolators).forEach(([morphId, interpolation]) => {
          const normal = normalize(value, start, end);
          let nextInterpolatedPath = "";
          let nextInterpolatedMatrix: number[] = [];

          if (interpolation.type === "Normal" || interpolation.type === "SubPath") {
            const { interpolator } = interpolation;
            nextInterpolatedPath = interpolator(normal);
          }

          if (interpolation.type === "Matrix") {
            const { interpolator } = interpolation;
            nextInterpolatedMatrix = interpolator(normal);
          }

          if (morphId in refs.current) {
            const thisRef = refs.current[morphId];

            if (Platform.OS === "web") {
              if (interpolation.type !== "Matrix") {
                thisRef?._touchableNode?.setAttribute("d", nextInterpolatedPath);
              } else {
                thisRef?._touchableNode?.setAttribute("transform", `matrix(${nextInterpolatedMatrix.join(" ")})`);
              }
            } else if (interpolation.type !== "Matrix") {
              thisRef?.setNativeProps({
                d: nextInterpolatedPath,
              });
            } else {
              thisRef?.setNativeProps({
                matrix: nextInterpolatedMatrix,
              });
            }
          }
        });
      };

      const listenerId = morphAnimVal.addListener(onValueChange);
      return () => morphAnimVal.removeListener(listenerId);
    }, [interpolations, start, end]);
    return (((ref: tPathRef) => {
      const id = ref?.props?.id ?? "unknown";

      if (refs && refs.current) {
        refs.current[`morphConfig${id}d`] = ref;
      }
    }) as unknown) as tMorphRef;
  };

  const myInterpolations: Array<tMorphInterpolation | tMatrixInterpolation> = React.useMemo(
    () => [
      {
        type: "Matrix",
        morphId: "morphConfigbaackgroundd",
        matrices: [
          [1, 0, 0, 1, 0, 0],
          [1, 2.5045070184415152e-17, 0, 0.9999999999999999, -0.6106000000000003, 0],
        ],
      },
      {
        type: "Matrix",
        morphId: "morphConfigdash2d",
        matrices: [
          [1, 0, 0, 1, 0, 0],
          [0.9999764711418555, 0, 0, 1.0323468685478323, -0.6085150937626622, -4.027185134205183],
        ],
      },
      {
        type: "Matrix",
        morphId: "morphConfigdash1d",
        matrices: [
          [1, 0, 0, 1, 0, 0],
          [1, 0, -1.1102230246251565e-16, 1.008613417520814, -0.6106000000000051, -1.0723704813413661],
        ],
      },
      {
        type: "Matrix",
        morphId: "morphConfigRectangle_20391d",
        matrices: [
          [1, 0, 0, 1, 0, 0],
          [1.0000000000000004, 1.5430086140836285e-16, -1.4210854715202004e-14, 1, -0.6122999999997774, 0],
        ],
      },
      {
        type: "Morph",
        morphId: "morphConfigVector_202d",
        paths: [
          "M71.0625 40.1292C75.7159 36.1108 80.8125 29.3625 83.6932 34.2356C87.3831 40.4775 77.0455 40.1292 71.0625 40.1292Z",
          "M66.285 35.8971C68.9563 30.3593 70.9485 22.1407 75.5297 25.466C81.3978 29.7254 71.7744 33.5175 66.285 35.8971Z",
        ],
      },
      {
        type: "Morph",
        morphId: "morphConfigVector_203d",
        paths: [
          "M71.5094 40.1292C66.856 36.1108 61.7594 29.3625 58.8787 34.2356C55.1888 40.4775 65.5264 40.1292 71.5094 40.1292Z",
          "M66.6953 35.7191C60.8276 33.883 53.4674 29.7184 52.7625 35.3352C51.8596 42.5298 61.2059 38.0987 66.6953 35.7191Z",
        ],
      },
      {
        type: "Matrix",
        morphId: "morphConfigSubtractd",
        matrices: [
          [1, 0, 0, 1, 0, 0],
          [1.000013162570914, 0, 0, 1, -0.6133853658537873, 0],
        ],
      },
      {
        type: "Matrix",
        morphId: "morphConfigTopd",
        matrices: [
          [1, 0, 0, 1, 0, 0],
          [
            0.9175043773530025,
            -0.39772657346960494,
            0.39763032236953677,
            0.9174616490983496,
            -14.870864859291942,
            27.343656959023974,
          ],
        ],
      },
      {
        type: "Morph",
        morphId: "morphConfigStar_201d",
        paths: [
          "M81.7069 47.0861C81.7325 47.0075 81.8437 47.0075 81.8693 47.0861V47.0861C81.8807 47.1213 81.9135 47.1451 81.9504 47.1451V47.1451C82.0331 47.1451 82.0675 47.2509 82.0006 47.2995V47.2995C81.9707 47.3212 81.9582 47.3598 81.9696 47.3949V47.3949C81.9951 47.4736 81.9051 47.539 81.8383 47.4904V47.4904C81.8083 47.4686 81.7678 47.4686 81.7379 47.4904V47.4904C81.671 47.539 81.581 47.4736 81.6066 47.3949V47.3949C81.618 47.3598 81.6055 47.3212 81.5756 47.2995V47.2995C81.5087 47.2509 81.5431 47.1451 81.6257 47.1451V47.1451C81.6627 47.1451 81.6955 47.1213 81.7069 47.0861V47.0861Z",
          "M91.1479 36.5157C91.4258 36.1456 92.014 36.3902 91.9475 36.8483L91.9283 36.9801C91.899 37.1823 92.0104 37.3786 92.199 37.457L92.4733 37.5711C92.8487 37.7273 92.8374 38.263 92.4558 38.4032L91.9301 38.5964C91.7761 38.6529 91.6655 38.7893 91.642 38.9516L91.577 39.399C91.513 39.8397 90.9143 39.9259 90.7286 39.5212L90.7111 39.4831C90.6138 39.2711 90.3698 39.1696 90.1508 39.2501L90.1115 39.2645C89.6935 39.4181 89.3326 38.9327 89.6 38.5767L89.8715 38.2151C89.97 38.084 89.9888 37.9094 89.9203 37.7603L89.6867 37.2514C89.5171 36.8818 89.8891 36.4962 90.2645 36.6523L90.5389 36.7665C90.7274 36.8449 90.9452 36.7855 91.0679 36.6222L91.1479 36.5157Z",
        ],
      },
      {
        type: "Morph",
        morphId: "morphConfigStar_202d",
        paths: [
          "M81.7069 47.0861C81.7325 47.0075 81.8437 47.0075 81.8693 47.0861V47.0861C81.8807 47.1213 81.9135 47.1451 81.9504 47.1451V47.1451C82.0331 47.1451 82.0675 47.2509 82.0006 47.2995V47.2995C81.9707 47.3212 81.9582 47.3598 81.9696 47.3949V47.3949C81.9951 47.4736 81.9051 47.539 81.8383 47.4904V47.4904C81.8083 47.4686 81.7678 47.4686 81.7379 47.4904V47.4904C81.671 47.539 81.581 47.4736 81.6066 47.3949V47.3949C81.618 47.3598 81.6055 47.3212 81.5756 47.2995V47.2995C81.5087 47.2509 81.5431 47.1451 81.6257 47.1451V47.1451C81.6627 47.1451 81.6955 47.1213 81.7069 47.0861V47.0861Z",
          "M100.003 37.4508C100.29 37.1265 100.824 37.3588 100.783 37.7897L100.774 37.875C100.756 38.0677 100.864 38.2505 101.041 38.3277L101.12 38.3618C101.517 38.5344 101.461 39.1142 101.038 39.208L100.955 39.2265C100.766 39.2685 100.625 39.4273 100.607 39.62L100.598 39.7053C100.557 40.1363 99.9882 40.2624 99.7684 39.8894L99.7249 39.8156C99.6266 39.6487 99.4321 39.5642 99.2431 39.6061L99.1594 39.6247C98.7368 39.7184 98.4411 39.2165 98.7279 38.8923L98.7847 38.8281C98.913 38.6831 98.9333 38.4719 98.835 38.3051L98.7915 38.2313C98.5718 37.8583 98.9577 37.422 99.3548 37.5946L99.4333 37.6288C99.6109 37.7059 99.818 37.66 99.9462 37.515L100.003 37.4508Z",
        ],
      },
      {
        type: "Morph",
        morphId: "morphConfigStar_203d",
        paths: [
          "M81.8898 47.211C81.9281 47.0931 82.095 47.0931 82.1333 47.211V47.211C82.1504 47.2638 82.1996 47.2995 82.2551 47.2995V47.2995C82.3791 47.2995 82.4306 47.4582 82.3303 47.5311V47.5311C82.2854 47.5637 82.2667 47.6215 82.2838 47.6742V47.6742C82.3221 47.7922 82.1871 47.8903 82.0868 47.8174V47.8174C82.0419 47.7848 81.9812 47.7848 81.9363 47.8174V47.8174C81.836 47.8903 81.701 47.7922 81.7393 47.6742V47.6742C81.7564 47.6215 81.7376 47.5637 81.6928 47.5311V47.5311C81.5924 47.4582 81.644 47.2995 81.768 47.2995V47.2995C81.8235 47.2995 81.8726 47.2638 81.8898 47.211V47.211Z",
          "M99.2912 42.5035C99.5905 42.1907 100.115 42.4436 100.057 42.8726L99.9142 43.9227C99.8882 44.1146 99.9886 44.3014 100.163 44.3855L101.118 44.8457C101.508 45.0337 101.429 45.6109 101.003 45.688L99.9604 45.8768C99.7698 45.9113 99.6232 46.0645 99.5971 46.2564L99.4544 47.3065C99.3962 47.7355 98.823 47.8393 98.618 47.458L98.1162 46.5245C98.0245 46.354 97.8334 46.2619 97.6429 46.2964L96.6001 46.4852C96.1741 46.5623 95.8983 46.0492 96.1976 45.7364L96.9303 44.9707C97.0641 44.8309 97.0927 44.6207 97.001 44.4502L96.4992 43.5167C96.2942 43.1354 96.6969 42.7145 97.0869 42.9025L98.0415 43.3628C98.2159 43.4468 98.4247 43.409 98.5585 43.2692L99.2912 42.5035Z",
        ],
      },
      {
        type: "Morph",
        morphId: "morphConfigStar_204d",
        paths: [
          "M81.8898 47.211C81.9281 47.0931 82.095 47.0931 82.1333 47.211V47.211C82.1504 47.2638 82.1996 47.2995 82.2551 47.2995V47.2995C82.3791 47.2995 82.4306 47.4582 82.3303 47.5311V47.5311C82.2854 47.5637 82.2667 47.6215 82.2838 47.6742V47.6742C82.3221 47.7922 82.1871 47.8903 82.0868 47.8174V47.8174C82.0419 47.7848 81.9812 47.7848 81.9363 47.8174V47.8174C81.836 47.8903 81.701 47.7922 81.7393 47.6742V47.6742C81.7564 47.6215 81.7376 47.5637 81.6928 47.5311V47.5311C81.5924 47.4582 81.644 47.2995 81.768 47.2995V47.2995C81.8235 47.2995 81.8726 47.2638 81.8898 47.211V47.211Z",
          "M97.3076 30.2091C97.682 30.0418 98.0653 30.425 97.8979 30.7995L97.3539 32.0168C97.2783 32.1859 97.3149 32.3841 97.4459 32.5151L98.4112 33.4804C98.7296 33.7988 98.4305 34.3349 97.9924 34.2313L96.8797 33.9683C96.6709 33.9189 96.4564 34.0249 96.3689 34.2208L95.9122 35.2427C95.7378 35.6329 95.1676 35.5791 95.0693 35.1631L94.7264 33.7127C94.6874 33.5481 94.5589 33.4196 94.3943 33.3807L92.9439 33.0377C92.5279 32.9394 92.4741 32.3692 92.8644 32.1948L93.8862 31.7382C94.0821 31.6506 94.1881 31.4362 94.1387 31.2273L93.8757 30.1147C93.7721 29.6765 94.3082 29.3775 94.6266 29.6958L95.5919 30.6611C95.7229 30.7921 95.9211 30.8287 96.0903 30.7531L97.3076 30.2091Z",
        ],
      },
    ],
    [],
  );
  morphProps.bindInterpolation = useGenerateMorphInterpolation(myInterpolations, startValue, endValue);
  const morphValues: {
    [id: string]: string[] | number[];
  } = {
    morphConfigdiscount_elem0x: [61.7867, 61.1761],
    morphConfigmyPromotionCopy_elem0x: [135.611, 135],
    morphConfigmyPromotionCopy_elem1x: [135.611, 135],
    morphConfigmyDiscountCode_elem0x: [135.611, 135],
    morphConfigmyDiscount_elem0x: [28.9987, 28.3881],
    morphConfigmyRestrictions_elem0x: [323.537, 322.926],
  };

  function clamp(lower: number, upper: number, v: number) {
    let r = v;

    if (r > upper) {
      r = upper;
    } else if (r < lower) {
      r = lower;
    }

    return r;
  }

  type tInterpolationRange = {
    inputRange: number[];
    outputRange: string[] | number[];
  };

  function getInterpolationRange(morphId: string, start: number, end: number): tInterpolationRange {
    const initial = clamp(0, 2, start);
    const final = clamp(0, 2, end);
    const inputRange = [start, end];
    const outputRange: string[] | number[] = [morphValues[morphId][initial], morphValues[morphId][final]] as
      | string[]
      | number[];

    if (start > end) {
      inputRange.reverse();
      outputRange.reverse();
    }

    return {
      inputRange,
      outputRange,
    };
  }

  morphProps.morphConfigdiscount_elem0x = morphAnimVal.interpolate(
    getInterpolationRange("morphConfigdiscount_elem0x", startValue, endValue),
  );
  morphProps.morphConfigmyPromotionCopy_elem0x = morphAnimVal.interpolate(
    getInterpolationRange("morphConfigmyPromotionCopy_elem0x", startValue, endValue),
  );
  morphProps.morphConfigmyPromotionCopy_elem1x = morphAnimVal.interpolate(
    getInterpolationRange("morphConfigmyPromotionCopy_elem1x", startValue, endValue),
  );
  morphProps.morphConfigmyDiscountCode_elem0x = morphAnimVal.interpolate(
    getInterpolationRange("morphConfigmyDiscountCode_elem0x", startValue, endValue),
  );
  morphProps.morphConfigmyDiscount_elem0x = morphAnimVal.interpolate(
    getInterpolationRange("morphConfigmyDiscount_elem0x", startValue, endValue),
  );
  morphProps.morphConfigmyRestrictions_elem0x = morphAnimVal.interpolate(
    getInterpolationRange("morphConfigmyRestrictions_elem0x", startValue, endValue),
  );
  React.useEffect(() => {
    const forwardMorph = [
      Animated.timing(morphAnimVal, {
        easing: Easing.ease,
        toValue: nextValue,
        duration: 500,
        delay: props.hasDelay ? 2000 : 0,
        useNativeDriver: false,
      }),
      Animated.timing(morphAnimVal, {
        easing: Easing.ease,
        toValue: nextValue,
        duration: 500,
        delay: props.hasDelay ? 0 : 0,
        useNativeDriver: false,
      }),
    ];

    const restartAnimation = () => {
      const nextInt = Math.ceil(nextValue);

      if (nextInt in forwardMorph) {
        forwardMorph[nextInt]?.start(() => {
          currValueRef.current = nextInt;
          onAnimationComplete();
        });
      }
    };

    if (morphAnimVal && morphAnimVal.stopAnimation) {
      morphAnimVal.stopAnimation(restartAnimation);
    } else {
      restartAnimation();
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nextValue]);
  /** End Morph Wrapper */

  /** Component Render (Javascript-React Markup) */

  if (Platform.OS === "web") {
    return (
      <View style={style}>
        <Svg
          fill="none"
          id="svg_root"
          ref={svgRef}
          style={svgStyle}
          preserveAspectRatio="xMinYMin meet"
          viewBox="0 0 652 170"
        >
          <G id="Open_3Dfalse">
            <Svg preserveAspectRatio="none" viewBox="0 0 652 170">
              <G id="PromotionNotice_20Master">
                <Svg preserveAspectRatio="xMinYMin meet" viewBox="0 0 652 170">
                  <Path
                    id="baackground"
                    fill="#F1F1F1"
                    stroke="#EDD4CB"
                    d="M1.1106 0.5 H651.1106 a0,0 0 0 1 0,0 V165.5 a0,0 0 0 1 -0,0 H1.1106 a0,0 0 0 1 -0,-0 V0.5 a0,0 0 0 1 0,-0z"
                    ref={morphProps.bindInterpolation}
                    strokeWidth="1"
                    vectorEffect="non-scaling-stroke"
                  />
                </Svg>
                <Svg preserveAspectRatio="xMinYMin meet" viewBox="0 0 652 170">
                  <Text
                    id="discount"
                    fill="#4F4F4F"
                    fontSize={14}
                    fontWeight={300}
                    letterSpacing="0.02em"
                    fontFamily={checkFont("Poppins")}
                  >
                    <TSpan y={130.4} id="discount_elem0" x={morphProps.morphConfigdiscount_elem0x ?? 61.7867}>
                      {"off"}
                    </TSpan>
                  </Text>
                </Svg>
                <Svg preserveAspectRatio="xMinYMin meet" viewBox="0 0 652 170">
                  <Path
                    id="dash2"
                    stroke="#4F4F4F"
                    d="M88.6106 124.5 L105.611 124.5 M88.6106 105.611z"
                    ref={morphProps.bindInterpolation}
                    strokeWidth="1"
                    vectorEffect="non-scaling-stroke"
                  />
                </Svg>
                <Svg preserveAspectRatio="xMinYMin meet" viewBox="0 0 652 170">
                  <Path
                    id="dash1"
                    stroke="#4F4F4F"
                    d="M36.6106 124.5 L53.6106 124.5 M36.6106 53.6106z"
                    ref={morphProps.bindInterpolation}
                    strokeWidth="1"
                    vectorEffect="non-scaling-stroke"
                  />
                </Svg>
                <Svg preserveAspectRatio="xMinYMin meet" viewBox="0 0 652 170">
                  <Text
                    id="myPromotionCopy"
                    fill="#373938"
                    fontSize={14}
                    fontWeight={300}
                    letterSpacing="0.02em"
                    fontFamily={checkFont("Poppins")}
                  >
                    <TSpan
                      y={100.4}
                      id="myPromotionCopy_elem0"
                      x={morphProps.morphConfigmyPromotionCopy_elem0x ?? 135.611}
                    >
                      {props.myDiscountCopy}
                    </TSpan>
                    {/* <TSpan
                      y={125.4}
                      id="myPromotionCopy_elem1"
                      x={morphProps.morphConfigmyPromotionCopy_elem1x ?? 135.611}
                    >
                      {"places with your customers."}
                    </TSpan> */}
                  </Text>
                </Svg>
                <Svg preserveAspectRatio="xMinYMin meet" viewBox="0 0 652 170">
                  <Text
                    id="myDiscountCode"
                    fill="#373938"
                    fontSize={28}
                    fontWeight={500}
                    letterSpacing="0.03em"
                    fontFamily={checkFont("Raleway")}
                  >
                    <TSpan
                      y={64.884}
                      id="myDiscountCode_elem0"
                      x={morphProps.morphConfigmyDiscountCode_elem0x ?? 135.611}
                    >
                      {props.myDiscountCode}
                    </TSpan>
                  </Text>
                </Svg>
                <Svg preserveAspectRatio="xMinYMin meet" viewBox="0 0 652 170">
                  <Text
                    id="myDiscount"
                    fill="#373938"
                    fontSize={32}
                    fontWeight={500}
                    letterSpacing="0.03em"
                    fontFamily={checkFont("Raleway")}
                  >
                    <TSpan y={106.296} id="myDiscount_elem0" x={morphProps.morphConfigmyDiscount_elem0x ?? 28.9987}>
                      {props.myDiscount}
                    </TSpan>
                  </Text>
                </Svg>
                <Svg preserveAspectRatio="xMinYMin meet" viewBox="0 0 652 170">
                  <Text
                    id="myRestrictions"
                    fill="#717171"
                    fontSize={14}
                    fontWeight={600}
                    letterSpacing="0.02em"
                    fontFamily={checkFont("Poppins")}
                  >
                    <TSpan
                      y={155.9}
                      id="myRestrictions_elem0"
                      x={morphProps.morphConfigmyRestrictions_elem0x ?? 323.537}
                    >
                      {props.myDiscountRestrictions}
                    </TSpan>
                  </Text>
                </Svg>
                <Svg preserveAspectRatio="xMinYMin meet" viewBox="0 0 652 170">
                  <G id="MagicBox">
                    <Svg preserveAspectRatio="xMinYMin meet" viewBox="0 0 652 170">
                      <Path
                        id="Rectangle_20391"
                        fill="#F1F1F1"
                        stroke="black"
                        d="M55.86786 47.5067 H86.70414 a1.11726,1.11726 0 0 1 1.11726,1.11726 V71.86284 a1.11726,1.11726 0 0 1 -1.11726,1.11726 H55.86786 a1.11726,1.11726 0 0 1 -1.11726,-1.11726 V48.623960000000004 a1.11726,1.11726 0 0 1 1.11726,-1.11726z"
                        ref={morphProps.bindInterpolation}
                        strokeWidth="2.23451"
                        vectorEffect="non-scaling-stroke"
                      />
                    </Svg>
                    <Svg preserveAspectRatio="xMinYMin meet" viewBox="0 0 652 170">
                      <Path
                        id="Vector_202"
                        d="M71.0625 40.1292C75.7159 36.1108 80.8125 29.3625 83.6932 34.2356C87.3831 40.4775 77.0455 40.1292 71.0625 40.1292Z"
                        fill="#F1F1F1"
                        stroke="black"
                        strokeLinejoin="round"
                        ref={morphProps.bindInterpolation}
                        strokeWidth="2.23451"
                        vectorEffect="non-scaling-stroke"
                      />
                    </Svg>
                    <Svg preserveAspectRatio="xMinYMin meet" viewBox="0 0 652 170">
                      <Path
                        id="Vector_203"
                        d="M71.5094 40.1292C66.856 36.1108 61.7594 29.3625 58.8787 34.2356C55.1888 40.4775 65.5264 40.1292 71.5094 40.1292Z"
                        fill="#F1F1F1"
                        stroke="black"
                        strokeLinejoin="round"
                        ref={morphProps.bindInterpolation}
                        strokeWidth="2.23451"
                        vectorEffect="non-scaling-stroke"
                      />
                    </Svg>
                    <Svg preserveAspectRatio="xMinYMin meet" viewBox="0 0 652 170">
                      <Path
                        id="Subtract"
                        d="M67.2639 61.3554V47.5067H74.8612V61.4068L72.4421 58.9429C71.6474 58.1334 70.3399 58.14 69.5543 58.9611L67.2639 61.3554ZM75.2441 61.7968L75.2438 61.7965L75.2441 61.7968Z"
                        stroke="black"
                        strokeLinejoin="round"
                        ref={morphProps.bindInterpolation}
                        strokeWidth="2.23451"
                        vectorEffect="non-scaling-stroke"
                      />
                    </Svg>
                    <Svg preserveAspectRatio="xMinYMin meet" viewBox="0 0 652 170">
                      <Path
                        id="Top"
                        d="M53.1864 40.803H88.9386C89.5557 40.803 90.0559 41.3033 90.0559 41.9203V46.3893C90.0559 47.0064 89.5557 47.5066 88.9386 47.5066H53.1864C52.5694 47.5066 52.0692 47.0064 52.0692 46.3893V41.9203C52.0692 41.3033 52.5694 40.803 53.1864 40.803Z"
                        fill="#F1F1F1"
                        stroke="black"
                        ref={morphProps.bindInterpolation}
                        strokeWidth="2.23451"
                        vectorEffect="non-scaling-stroke"
                      />
                    </Svg>
                    <Svg preserveAspectRatio="xMinYMin meet" viewBox="0 0 652 170">
                      <Path
                        id="Star_201"
                        d="M81.7069 47.0861C81.7325 47.0075 81.8437 47.0075 81.8693 47.0861V47.0861C81.8807 47.1213 81.9135 47.1451 81.9504 47.1451V47.1451C82.0331 47.1451 82.0675 47.2509 82.0006 47.2995V47.2995C81.9707 47.3212 81.9582 47.3598 81.9696 47.3949V47.3949C81.9951 47.4736 81.9051 47.539 81.8383 47.4904V47.4904C81.8083 47.4686 81.7678 47.4686 81.7379 47.4904V47.4904C81.671 47.539 81.581 47.4736 81.6066 47.3949V47.3949C81.618 47.3598 81.6055 47.3212 81.5756 47.2995V47.2995C81.5087 47.2509 81.5431 47.1451 81.6257 47.1451V47.1451C81.6627 47.1451 81.6955 47.1213 81.7069 47.0861V47.0861Z"
                        fill="black"
                        ref={morphProps.bindInterpolation}
                        strokeWidth="1"
                        vectorEffect="non-scaling-stroke"
                      />
                    </Svg>
                    <Svg preserveAspectRatio="xMinYMin meet" viewBox="0 0 652 170">
                      <Path
                        id="Star_202"
                        d="M81.7069 47.0861C81.7325 47.0075 81.8437 47.0075 81.8693 47.0861V47.0861C81.8807 47.1213 81.9135 47.1451 81.9504 47.1451V47.1451C82.0331 47.1451 82.0675 47.2509 82.0006 47.2995V47.2995C81.9707 47.3212 81.9582 47.3598 81.9696 47.3949V47.3949C81.9951 47.4736 81.9051 47.539 81.8383 47.4904V47.4904C81.8083 47.4686 81.7678 47.4686 81.7379 47.4904V47.4904C81.671 47.539 81.581 47.4736 81.6066 47.3949V47.3949C81.618 47.3598 81.6055 47.3212 81.5756 47.2995V47.2995C81.5087 47.2509 81.5431 47.1451 81.6257 47.1451V47.1451C81.6627 47.1451 81.6955 47.1213 81.7069 47.0861V47.0861Z"
                        fill="black"
                        ref={morphProps.bindInterpolation}
                        strokeWidth="1"
                        vectorEffect="non-scaling-stroke"
                      />
                    </Svg>
                    <Svg preserveAspectRatio="xMinYMin meet" viewBox="0 0 652 170">
                      <Path
                        id="Star_203"
                        d="M81.8898 47.211C81.9281 47.0931 82.095 47.0931 82.1333 47.211V47.211C82.1504 47.2638 82.1996 47.2995 82.2551 47.2995V47.2995C82.3791 47.2995 82.4306 47.4582 82.3303 47.5311V47.5311C82.2854 47.5637 82.2667 47.6215 82.2838 47.6742V47.6742C82.3221 47.7922 82.1871 47.8903 82.0868 47.8174V47.8174C82.0419 47.7848 81.9812 47.7848 81.9363 47.8174V47.8174C81.836 47.8903 81.701 47.7922 81.7393 47.6742V47.6742C81.7564 47.6215 81.7376 47.5637 81.6928 47.5311V47.5311C81.5924 47.4582 81.644 47.2995 81.768 47.2995V47.2995C81.8235 47.2995 81.8726 47.2638 81.8898 47.211V47.211Z"
                        fill="black"
                        ref={morphProps.bindInterpolation}
                        strokeWidth="1"
                        vectorEffect="non-scaling-stroke"
                      />
                    </Svg>
                    <Svg preserveAspectRatio="xMinYMin meet" viewBox="0 0 652 170">
                      <Path
                        id="Star_204"
                        d="M81.8898 47.211C81.9281 47.0931 82.095 47.0931 82.1333 47.211V47.211C82.1504 47.2638 82.1996 47.2995 82.2551 47.2995V47.2995C82.3791 47.2995 82.4306 47.4582 82.3303 47.5311V47.5311C82.2854 47.5637 82.2667 47.6215 82.2838 47.6742V47.6742C82.3221 47.7922 82.1871 47.8903 82.0868 47.8174V47.8174C82.0419 47.7848 81.9812 47.7848 81.9363 47.8174V47.8174C81.836 47.8903 81.701 47.7922 81.7393 47.6742V47.6742C81.7564 47.6215 81.7376 47.5637 81.6928 47.5311V47.5311C81.5924 47.4582 81.644 47.2995 81.768 47.2995V47.2995C81.8235 47.2995 81.8726 47.2638 81.8898 47.211V47.211Z"
                        fill="black"
                        ref={morphProps.bindInterpolation}
                        strokeWidth="1"
                        vectorEffect="non-scaling-stroke"
                      />
                    </Svg>
                  </G>
                </Svg>
              </G>
            </Svg>
          </G>
        </Svg>
      </View>
    );
  }

  return (
    <View style={style}>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 652 170"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="baackground"
          fill="#F1F1F1"
          stroke="#EDD4CB"
          d="M1.1106 0.5 H651.1106 a0,0 0 0 1 0,0 V165.5 a0,0 0 0 1 -0,0 H1.1106 a0,0 0 0 1 -0,-0 V0.5 a0,0 0 0 1 0,-0z"
          ref={morphProps.bindInterpolation}
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 652 170"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Text
          id="discount"
          fill="#4F4F4F"
          fontSize={14}
          fontWeight={300}
          letterSpacing="0.02em"
          fontFamily={checkFont("Poppins")}
        >
          <TSpan y={130.4} id="discount_elem0" x={morphProps.morphConfigdiscount_elem0x ?? 61.7867}>
            {"off"}
          </TSpan>
        </Text>
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 652 170"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="dash2"
          stroke="#4F4F4F"
          d="M88.6106 124.5 L105.611 124.5 M88.6106 105.611z"
          ref={morphProps.bindInterpolation}
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 652 170"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="dash1"
          stroke="#4F4F4F"
          d="M36.6106 124.5 L53.6106 124.5 M36.6106 53.6106z"
          ref={morphProps.bindInterpolation}
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 652 170"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Text
          id="myPromotionCopy"
          fill="#373938"
          fontSize={14}
          fontWeight={300}
          letterSpacing="0.02em"
          fontFamily={checkFont("Poppins")}
        >
          <TSpan y={100.4} id="myPromotionCopy_elem0" x={morphProps.morphConfigmyPromotionCopy_elem0x ?? 135.611}>
            {props.myDiscountCopy}
          </TSpan>
          {/* <TSpan y={125.4} id="myPromotionCopy_elem1" x={morphProps.morphConfigmyPromotionCopy_elem1x ?? 135.611}>
            {"places with your customers."}
          </TSpan> */}
        </Text>
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 652 170"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Text
          id="myDiscountCode"
          fill="#373938"
          fontSize={28}
          fontWeight={500}
          letterSpacing="0.03em"
          fontFamily={checkFont("Raleway")}
        >
          <TSpan y={64.884} id="myDiscountCode_elem0" x={morphProps.morphConfigmyDiscountCode_elem0x ?? 135.611}>
            {props.myDiscountCode}
          </TSpan>
        </Text>
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 652 170"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Text
          id="myDiscount"
          fill="#373938"
          fontSize={32}
          fontWeight={500}
          letterSpacing="0.03em"
          fontFamily={checkFont("Raleway")}
        >
          <TSpan y={106.296} id="myDiscount_elem0" x={morphProps.morphConfigmyDiscount_elem0x ?? 28.9987}>
            {props.myDiscount}
          </TSpan>
        </Text>
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 652 170"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Text
          id="myRestrictions"
          fill="#717171"
          fontSize={14}
          fontWeight={600}
          letterSpacing="0.02em"
          fontFamily={checkFont("Poppins")}
        >
          <TSpan y={155.9} id="myRestrictions_elem0" x={morphProps.morphConfigmyRestrictions_elem0x ?? 323.537}>
            {props.myDiscountRestrictions}
          </TSpan>
        </Text>
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 652 170"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <G id="MagicBox">
          <Path
            id="Rectangle_20391"
            fill="#F1F1F1"
            stroke="black"
            d="M55.86786 47.5067 H86.70414 a1.11726,1.11726 0 0 1 1.11726,1.11726 V71.86284 a1.11726,1.11726 0 0 1 -1.11726,1.11726 H55.86786 a1.11726,1.11726 0 0 1 -1.11726,-1.11726 V48.623960000000004 a1.11726,1.11726 0 0 1 1.11726,-1.11726z"
            ref={morphProps.bindInterpolation}
            strokeWidth="2.23451"
            vectorEffect="non-scaling-stroke"
          />
          <Path
            id="Vector_202"
            d="M71.0625 40.1292C75.7159 36.1108 80.8125 29.3625 83.6932 34.2356C87.3831 40.4775 77.0455 40.1292 71.0625 40.1292Z"
            fill="#F1F1F1"
            stroke="black"
            strokeLinejoin="round"
            ref={morphProps.bindInterpolation}
            strokeWidth="2.23451"
            vectorEffect="non-scaling-stroke"
          />
          <Path
            id="Vector_203"
            d="M71.5094 40.1292C66.856 36.1108 61.7594 29.3625 58.8787 34.2356C55.1888 40.4775 65.5264 40.1292 71.5094 40.1292Z"
            fill="#F1F1F1"
            stroke="black"
            strokeLinejoin="round"
            ref={morphProps.bindInterpolation}
            strokeWidth="2.23451"
            vectorEffect="non-scaling-stroke"
          />
          <Path
            id="Subtract"
            d="M67.2639 61.3554V47.5067H74.8612V61.4068L72.4421 58.9429C71.6474 58.1334 70.3399 58.14 69.5543 58.9611L67.2639 61.3554ZM75.2441 61.7968L75.2438 61.7965L75.2441 61.7968Z"
            stroke="black"
            strokeLinejoin="round"
            ref={morphProps.bindInterpolation}
            strokeWidth="2.23451"
            vectorEffect="non-scaling-stroke"
          />
          <Path
            id="Top"
            d="M53.1864 40.803H88.9386C89.5557 40.803 90.0559 41.3033 90.0559 41.9203V46.3893C90.0559 47.0064 89.5557 47.5066 88.9386 47.5066H53.1864C52.5694 47.5066 52.0692 47.0064 52.0692 46.3893V41.9203C52.0692 41.3033 52.5694 40.803 53.1864 40.803Z"
            fill="#F1F1F1"
            stroke="black"
            ref={morphProps.bindInterpolation}
            strokeWidth="2.23451"
            vectorEffect="non-scaling-stroke"
          />
          <Path
            id="Star_201"
            d="M81.7069 47.0861C81.7325 47.0075 81.8437 47.0075 81.8693 47.0861V47.0861C81.8807 47.1213 81.9135 47.1451 81.9504 47.1451V47.1451C82.0331 47.1451 82.0675 47.2509 82.0006 47.2995V47.2995C81.9707 47.3212 81.9582 47.3598 81.9696 47.3949V47.3949C81.9951 47.4736 81.9051 47.539 81.8383 47.4904V47.4904C81.8083 47.4686 81.7678 47.4686 81.7379 47.4904V47.4904C81.671 47.539 81.581 47.4736 81.6066 47.3949V47.3949C81.618 47.3598 81.6055 47.3212 81.5756 47.2995V47.2995C81.5087 47.2509 81.5431 47.1451 81.6257 47.1451V47.1451C81.6627 47.1451 81.6955 47.1213 81.7069 47.0861V47.0861Z"
            fill="black"
            ref={morphProps.bindInterpolation}
            strokeWidth="1"
            vectorEffect="non-scaling-stroke"
          />
          <Path
            id="Star_202"
            d="M81.7069 47.0861C81.7325 47.0075 81.8437 47.0075 81.8693 47.0861V47.0861C81.8807 47.1213 81.9135 47.1451 81.9504 47.1451V47.1451C82.0331 47.1451 82.0675 47.2509 82.0006 47.2995V47.2995C81.9707 47.3212 81.9582 47.3598 81.9696 47.3949V47.3949C81.9951 47.4736 81.9051 47.539 81.8383 47.4904V47.4904C81.8083 47.4686 81.7678 47.4686 81.7379 47.4904V47.4904C81.671 47.539 81.581 47.4736 81.6066 47.3949V47.3949C81.618 47.3598 81.6055 47.3212 81.5756 47.2995V47.2995C81.5087 47.2509 81.5431 47.1451 81.6257 47.1451V47.1451C81.6627 47.1451 81.6955 47.1213 81.7069 47.0861V47.0861Z"
            fill="black"
            ref={morphProps.bindInterpolation}
            strokeWidth="1"
            vectorEffect="non-scaling-stroke"
          />
          <Path
            id="Star_203"
            d="M81.8898 47.211C81.9281 47.0931 82.095 47.0931 82.1333 47.211V47.211C82.1504 47.2638 82.1996 47.2995 82.2551 47.2995V47.2995C82.3791 47.2995 82.4306 47.4582 82.3303 47.5311V47.5311C82.2854 47.5637 82.2667 47.6215 82.2838 47.6742V47.6742C82.3221 47.7922 82.1871 47.8903 82.0868 47.8174V47.8174C82.0419 47.7848 81.9812 47.7848 81.9363 47.8174V47.8174C81.836 47.8903 81.701 47.7922 81.7393 47.6742V47.6742C81.7564 47.6215 81.7376 47.5637 81.6928 47.5311V47.5311C81.5924 47.4582 81.644 47.2995 81.768 47.2995V47.2995C81.8235 47.2995 81.8726 47.2638 81.8898 47.211V47.211Z"
            fill="black"
            ref={morphProps.bindInterpolation}
            strokeWidth="1"
            vectorEffect="non-scaling-stroke"
          />
          <Path
            id="Star_204"
            d="M81.8898 47.211C81.9281 47.0931 82.095 47.0931 82.1333 47.211V47.211C82.1504 47.2638 82.1996 47.2995 82.2551 47.2995V47.2995C82.3791 47.2995 82.4306 47.4582 82.3303 47.5311V47.5311C82.2854 47.5637 82.2667 47.6215 82.2838 47.6742V47.6742C82.3221 47.7922 82.1871 47.8903 82.0868 47.8174V47.8174C82.0419 47.7848 81.9812 47.7848 81.9363 47.8174V47.8174C81.836 47.8903 81.701 47.7922 81.7393 47.6742V47.6742C81.7564 47.6215 81.7376 47.5637 81.6928 47.5311V47.5311C81.5924 47.4582 81.644 47.2995 81.768 47.2995V47.2995C81.8235 47.2995 81.8726 47.2638 81.8898 47.211V47.211Z"
            fill="black"
            ref={morphProps.bindInterpolation}
            strokeWidth="1"
            vectorEffect="non-scaling-stroke"
          />
        </G>
      </Svg>
    </View>
  );
};
/***/

export default React.memo(PromotionNotice);
